module.exports = __webpack_public_path__ + "static/media/AirbnbCerealApp-Black.69f11bb5.woff2";